import React from "react";

export default function Tags({ tags }) {
  return (
    <>
      {tags?.length > 0 && (
        <div className="tags" id="lws-singleTags">
          {tags.map((tag) => (
            <span key={tag}>#{tag}, </span>
          ))}
        </div>
      )}
    </>
  );
}
